import { addClass, removeClass } from '@/utils';
import { mainApi } from '@/api';
import { API_RETURN_CODE } from '@/utils/variables';

const actions = {};

/**
 * 회원 정보
 *  @param {*} param0
 */
actions.setLogin = ({ commit }, isLogin) => {
  commit('SET_IS_LOGIN', isLogin);
};

/**
 * Point 종류
 *  @param {*} param0
 */
actions.setServiceInfo = ({ commit }, val) => {
  commit('SET_SERVICEINFO', val);
};

actions.setServiceUrl = ({ commit }, val) => {
  commit('SET_SERVICEURL', val);
};

// getPointThumbnailList
actions.setPointThumbnailList = ({ commit }) => {
  return mainApi.getPointThumbnailList().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      const { data } = res.data;
      commit('SET_POINT_THUMBNAIL_LIST', data.rpServiceInfoList);
    } else {
      commit('SET_POINT_THUMBNAIL_LIST', []);
    }

    return res.data.code;
  });
};

// pointList
actions.setPointList = ({ commit }) => {
  return mainApi.getPointList().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      const { data } = res.data;
      commit('SET_POINTLIST', data.rpServiceInfoList);
    } else {
      commit('SET_POINTLIST', []);
    }

    return res.data.code;
  });
};

/**
 * Point 전환 레이어 URL
 *  @param {*} param0
 */
actions.setExchangeLayerUrl = ({ commit }, val) => {
  commit('SET_EXCHANGELAYERURL', val);
  if (val === '') {
    removeClass(document.body, 'scroll_hide_frame');
  } else {
    addClass(document.body, 'scroll_hide_frame');
  }
};

/**
 * Point 전환 아이프레임 여부
 *  @param {*} param0
 */
actions.setExchangeIframe = ({ commit }, val) => {
  commit('SET_EXCHANGEIFRAME', val);
};

export default {
  ...actions,
};
